import React from 'react'

import { Container, NameSkeleton } from './GridPublicationItem.styles'
import { PublicationThumbnailSkeleton } from '../PublicationThumbnail'

export const GridPublicationItemPlaceholder: React.FC = ({ children }) => {
  return (
    <Container>
      {children}
      <PublicationThumbnailSkeleton />
      <NameSkeleton />
    </Container>
  )
}
